// Move GoWish button next to the buy button (no rails, no WK handling)
(() => {
  const GOWISH_SELECTOR = '#gowishBlueButton';
  const GOWISH_WRAPPER  = '.gw-btn-wrapper';

  function q(s, sel){ try { return s.querySelector(sel); } catch { return null; } }

  function getAtcRow(section){
    return q(section, '.atc-quantity-container') ||
           q(section, '.product-form__buttons') ||
           section;
  }

  function moveGoWish(section){
    if (!section.querySelector('form[action="/cart/add"]')) return;

    const atcRow = getAtcRow(section);
    if (!atcRow) return;

    // Find rendered GoWish wrapper
    const btn = section.querySelector(GOWISH_SELECTOR);
    if (!btn) return;
    const wrap = btn.closest(GOWISH_WRAPPER) || btn;

    // Place it as a sibling to <product-form>, right after it
    const productFormEl = q(atcRow, ':scope > product-form');
    if (productFormEl && wrap.parentElement !== atcRow) {
      wrap.style.margin = '0'; // neutralize app margins
      productFormEl.insertAdjacentElement('afterend', wrap);
      wrap.setAttribute('data-wishlist-mounted', 'true');
    }
  }

  function hydrate(scope=document){
    scope.querySelectorAll('[id^="shopify-section-"]').forEach(sec => moveGoWish(sec));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => hydrate());
  } else {
    hydrate();
  }
  document.addEventListener('shopify:section:load', e => hydrate(e.target));
  document.addEventListener('shopify:section:select', e => hydrate(e.target));

  // Re-run if GoWish injects late
  const mo = new MutationObserver(muts => {
    for (const m of muts) {
      for (const n of m.addedNodes) {
        if (n.nodeType !== 1) continue;
        if (n.matches?.(GOWISH_SELECTOR) || n.querySelector?.(GOWISH_SELECTOR)) {
          hydrate();
          return;
        }
      }
    }
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();